module.exports = __webpack_public_path__ + "static/media/yancey-official-blog-svg-icons.afd891c7.svg";